import React from 'react';
import { ButtonProps } from './Button.types';
import { Loader } from 'react-feather';
import { theme } from './theme';
import { getButtonStyles } from './styleUtils';
import './Button.css';

const Button: React.FC<ButtonProps> = ({
	onClick,
	loading,
	disabled,
	color,
	size,
	startIcon,
	endIcon,
	label,
	textOnly,
	type = 'button',
	dataTestId
}) => {
	const dynamicStyles = getButtonStyles(theme, !!startIcon || !!endIcon, size, color, textOnly);
	if (loading) {
		return (
			<button
				data-testid={dataTestId}
				disabled={disabled}
				className={`button button-${color} loading ${disabled ? 'disabled' : ' '} icon`}
				style={dynamicStyles}
			>
				<Loader
					color="white"
					size={24}
					height={24}
					data-testid="loader"
					className="spin-animation"
				/>
				{label}
			</button>
		);
	}
	return (
		<button
			onClick={onClick}
			data-testid={dataTestId}
			disabled={disabled}
			className={`button ${disabled ? 'disabled' : ' '} ${size} ${startIcon || endIcon ? 'icon' : ' '}`}
			style={dynamicStyles}
			type={type}
		>
			{startIcon}
			{label}
			{endIcon}
		</button>
	);
};

export default Button;
